module.exports = __webpack_public_path__ + "static/media/absolute.8008a906.svg";